<template>
  <div class="p-4">
    <div class="table w-full">
        <div class="table-row-group">
            <div class="table-row">
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold "> {{$t('name')}}</div>
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold">{{ sensor.name }}</div>
            </div>
            <div class="table-row">
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold">{{$t('description')}}</div>
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold">{{ sensor.description}}</div>
            </div>
            <div class="table-row">
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold">{{$t('components')}}</div>
            <div class="table-cell bg-gray-400 text-gray-700 px-4 py-2 font-bold">{{ strcomponents}}</div>
            </div>
        </div>
    </div>
    <br/>
<!--     <apexchart width="100%" height="300" type="line" ref='apex' :options="chartOptions" :series="series"></apexchart>  -->

    <highcharts width="100%" height="500px" class="chart" :options="chartOptions" ref="lineCharts"></highcharts> 

  </div>
</template>

<script>

import Notify from "@/helpers/notify";
import ObservationsService from "../../helpers/apiservices/observations/observations.service";
import ComponentsService from "../../helpers/apiservices/components/components.service";
import ApexchartHelper from "@/helpers/settings/apexchart";
import * as moment from "moment";


export default {
    name: "sensorplot",
    props: [
        'sensor',
        'selection'
    ],
    watch: { 
      	selection: async function(newVal, oldVal) { 
           Notify.loadData(null, await this.loadData);
        },
    },
    data() {
        return {
            error: "",
            loading: false,
            series: [],
            options: ApexchartHelper.settings(this.id, true),
            dataReceived: false,
            title: '',
            chartOptions: {
                chart: {
                    type: 'line',
                    boostThreshold: 1,
                    turboThreshold: 0,
                    animation: true,
                },
                title: {
                    text: this.sensor.name
                },
                xAxis: {
                        type: 'datetime', 
                        labels: {
                            rotation: -45,
                            formatter: function () {                
                                return moment(new Date(this.value)).format('DD/MM/YY HH:mm');
                            },
                            style:{
                                fontSize: "8px"
                            }
                        }
                    },
                yAxis: {
                    allowDecimals: true,
                    labels: {
                        formatter: function () {                
                            return this.value;
                        }
                    }
                },
                series: [],
                exporting: {
                    enabled: true,
                    csv: {
                        itemDelimiter: ';'
                    },
                }
            }
        };
    },
    computed: {
        strcomponents: function() {
            let strcomp = this.sensor.components.map(s => s.name);
            return strcomp.join(',');
        },
        filtering: function(){
            return {
                datefrom : this.selection.filterDateFrom,
                dateto: this.selection.filterDateTo,
                sensorid: this.sensor.id,
                filteroption: this.selection.filtering,
                providerid: this.sensor.provider.id
            };
        },
    },
    mounted() {
        Notify.loadData(null, this.loadInitialData);

    },

    methods: {
        async loadData () {
            switch(this.filtering.filteroption) {
                case this.$parent.FilteringOptions.olddata:
                    this.sensor.observations = await ObservationsService.sensorobservationsOld(this.filtering); 
                break;
                case this.$parent.FilteringOptions.newdata:
                    this.sensor.observations = await ObservationsService.sensorobservations(this.filtering);
                break;
                //default - date range
                default:
                    this.sensor.observations = await ObservationsService.sensorobservationsTS(this.filtering);
                    break;
            }
            
            //clear series and graph
            let mseries = []
            var series_ids = [];
            for (var s in this.$refs.lineCharts.chart.series) {
                series_ids.push(this.$refs.lineCharts.chart.series[s].options.id);
            }
            for (var id in series_ids) {
                this.$refs.lineCharts.chart.get(series_ids[id]).remove(true);
            }

            //One serie for each component
             var unique = [...new Set(this.sensor.observations.map(o => o.component))]; //
            
            let compmeasurements;
            for(var u = 0; u < unique.length; u++){
                compmeasurements  = this.sensor.observations.filter(o => o.component === unique[u]); // all measurements for this component
                let d = [];
                for(var m = 0; m < compmeasurements.length; m++){
                    if(compmeasurements[m].value != -9900){
                        //d.push([moment.unix(m.timestamp_to_epoch), m.value])
                        d.push([compmeasurements[m].timestamp_to_epoch * 1000, compmeasurements[m].value])

                    }
                }
                if(d.length>0){
                    d.sort(function(a,b){
                        return a[0] - b[0];
                    });

                    mseries.push({name : unique[u], data: d });
                    this.$refs.lineCharts.chart.addSeries({id: unique[u], name: unique[u] , data: d, visible: this.IsDefaultComponent(unique[u])}); 
                }
            } 

            this.series = mseries;
            this.dataReceived = true; 

        },
        async loadInitialData() {
            this.ndComponents = await ComponentsService.ndcomponents();
            await this.loadData();
        },

        IsDefaultComponent(compName){
            return this.ndComponents.some(el => el.name === compName);
        },

        SetDefaultSeries: function() {
            //uncheck all series and only show default - but show if only two
            if(this.series.length > 2){
                this.series.forEach(s => {
                    this.$refs.apex.chart.toggleSeries(s.name.toString())
                });
                //Check default components
                this.ndComponents.forEach(comp => {
                    try{
                        this.$refs.apex.chart.toggleSeries(comp.name);
                    }
                    catch(err){
                        //Its okay if there are no series that matches
                    }
                });
            }
        } 
    }
};
</script>



